module.exports = __webpack_public_path__ + "img/parameter10.9b07760.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/parameter10.jpg
// module id = qIMe
// module chunks = 0